import React from "react"
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton, componentStyles } from "@mallardbay/lib-react-components"

import { useResponsiveValue } from "~utils/hooks/use-responsive"

type Props = {
    readonly onClick: () => void
}

export default function SidebarDrawerButton({ onClick }: Props) {
    const styles = useStyles()
    const display = useResponsiveValue(["flex", "flex", "none"])

    if (display === "none") return null

    return (
        <IconButton
            variant="outline"
            ariaLabel="menu-button"
            icon={<FontAwesomeIcon icon={faBars} fontSize={20} />}
            onClick={onClick}
            style={styles.button}
        />
    )
}

function useStyles() {
    return componentStyles({
        button: {
            borderRadius: "9999px",
        },
    })
}
